import DefaultNoAccessComponent from './DefaultNoAccessComponent';

export default DefaultNoAccessComponent;